import { createStore } from "vuex";

export default createStore({
  state: {
    navIndex: 0,
    navData: [{ path: "HomeMain", title: "首页" }],
  },
  mutations: {
    setLoginUser(state, data) {
      console.log(data);
      state.loginUser = data;
      console.log(data);
    },

    onNavInit(state) {
      const nav = localStorage.getItem("navData");
      if (nav) {
        state.navData = [{ path: "HomeMain", title: "首页" }, JSON.parse(nav)];
        state.navIndex = 1;
      }
    },

    //打开菜单
    openMenu(state, data) {
      let index = state.navData.findIndex(
        (w) =>
          w.path == data.path &&
          JSON.stringify(w.data) == JSON.stringify(data.data)
      );
      if (index < 0) {
        // 新标签必须生成唯一 key，避免快速点击时 Vue 复用组件实例导致内容错乱
        data.key = Math.random();
        state.navData.splice(state.navIndex + 1, 0, data);
        state.navIndex = state.navIndex + 1;
      } else {
        state.navIndex = index;
        console.log(data);
        if (data.refresh) {
          state.navData[index].key = Math.random();
        }
      }

      localStorage.setItem("navData", JSON.stringify(data));
    },

    //关闭当前菜单
    onCloseMy(state, index) {
      state.navData.splice(index, 1);
      // 只有被关闭的标签在当前或之前，才需要调整 navIndex
      if (index <= state.navIndex) {
        state.navIndex = Math.max(0, state.navIndex - 1);
      }
      // 确保 navIndex 不超出数组范围
      if (state.navIndex >= state.navData.length) {
        state.navIndex = Math.max(0, state.navData.length - 1);
      }
    },

    //关闭当前菜单
    onCloseCurrent(state) {
      state.navData.splice(state.navIndex, 1);
      state.navIndex = state.navIndex - 1;
    },

    //关闭其他菜单
    onCloseOther(state, index) {
      if (index == 0) {
        state.navData = [{ path: "HomeMain", title: "首页" }];
        state.navIndex = 0;
      } else {
        state.navData = [
          { path: "HomeMain", title: "首页" },
          state.navData[index],
        ];
        state.navIndex = 1;
      }
    },

    //刷新当前标签
    onRefresh(state, index) {
      state.navData[index].key = Math.random();
    },

    //刷新当前标签
    onRefreshCurrent(state) {
      state.navData[state.navIndex].key = Math.random();
    },
  },
  actions: {},
  modules: {},
});
